import {
  createEmptySliceBase,
  injectDetailSlice,
  injectTableSlice,
  toReducer
} from '../sliceFactory';

const createRequestTypesReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'requestTypes' });
  const withTable = injectTableSlice({ sliceBase });
  const withDetail = injectDetailSlice({ sliceBase: withTable });
  return toReducer(withDetail);
};

export default createRequestTypesReducer;
